/* Publish by EComposer at 2024-06-06 18:13:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-47lysqt5sp"]=  window.__ectimmers["ecom-47lysqt5sp"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-47lysqt5sp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-47lysqt5sp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pndzdagh0ul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pndzdagh0ul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbc98zt13jc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbc98zt13jc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qt0j4xg1lb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qt0j4xg1lb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sfrpa3ve4l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sfrpa3ve4l', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eg4aeqqcygt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eg4aeqqcygt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4e0838mefb2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4e0838mefb2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dhzaar3eza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dhzaar3eza', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-29mtltbba7m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29mtltbba7m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bkutm3te0eu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkutm3te0eu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ban3pftt99').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ban3pftt99', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x2sngk23o1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x2sngk23o1k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8jktvz80le').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8jktvz80le', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-plh8cbhgwfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-plh8cbhgwfh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qp49gqsd6d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qp49gqsd6d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gidkw2grpum').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gidkw2grpum', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rbh3ba57eu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rbh3ba57eu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3dv9b7hz8lq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3dv9b7hz8lq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7q2ap4e79x4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7q2ap4e79x4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-upzap7ajdpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-upzap7ajdpn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mk3lynpa7h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mk3lynpa7h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lk2ytics9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lk2ytics9u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8j938yzzivw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8j938yzzivw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9wwzle3my2f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9wwzle3my2f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cs5cxtxkrkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cs5cxtxkrkl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l6cq951swka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l6cq951swka', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x6ob7z4oil').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x6ob7z4oil', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgl4wn1pvua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgl4wn1pvua', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vj8xa5g9zk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vj8xa5g9zk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvymzygmxca').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvymzygmxca', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1t2vi0xay94').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1t2vi0xay94', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h62yafj1t4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h62yafj1t4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ux7f8i6erk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ux7f8i6erk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jivnc6n2x08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jivnc6n2x08', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3wplcisla2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3wplcisla2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e5ddnukzgsb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e5ddnukzgsb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sm9j5gu3fs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sm9j5gu3fs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ohfuq2vmbv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ohfuq2vmbv', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);};window.addEventListener("load",()=>{
                let isAdmin = false;
                if(document.querySelector("#admin-bar-iframe")){
                    isAdmin = true;
                }
                if(!isAdmin) {
                    if(window.EComposerBrand) {
                        return;
                    } else {
                        window.EComposerBrand = true;
                    }
                }
                let a=document.querySelector("body"),b=document.createElement(Math.random().toString(36).replace(/\d*/g,"").substr(2,4));b.setAttribute("style",["position:relative","top: 0px","left: 0px","display: inline-block","height: 30px","line-height: 30px","font-size: 11px","width: 100%","text-align: center","opacity: 1","text-indent: 0","color: rgba(18, 18, 18, 0.75)","background: transparent","opacity: 0.8",""].join(" !important;")),b.innerHTML="Built with <a style='color: currentColor;text-decoration: none;' href=\"https://ecomposer.io/?utm_source=client-site&utm_medium=footer&utm_campaign=footer_branding&utm_term=links&utm_content="+window.location.origin+"\" target=\"_blank\">EComposer</a>" + (isAdmin ? ". Contact us or upgrade to remove branding" :""),a.appendChild(b)
            });